import React from 'react';

import TabItem from '../UI/TabItem';


const FirstSection = (props) => {

    const displayPopupOnClick = (props) =>{
        console.log("clickImage in  FirstSection:::",props);
        props.onClick(props);
    }

    const categoryHasId = (value) =>{
        return  value.toLowerCase().replace(/\s+/g, "-");
    }
    console.log("props in firstSection ::::",props.item);
    return (
        <> 
            {(props.item.category1[0] && props.item.category1[0].title) && 
            <h3 id={categoryHasId(props.item.category1[0].title)}> {props.item.category1[0].title} </h3>}
            {(props.item.category1[0] && props.item.category1[0].tabpanel && props.item.category1[0].tab) && <TabItem tabPanels={props.item.category1[0].tabpanel} tabs={props.item.category1[0].tab} onClick = {()=>displayPopupOnClick(props)}/>}
        </>
    )
}

export default FirstSection;
